import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import * as Sentry from "@sentry/angular";
import { environment } from './environments/environment';

Sentry.init({
  dsn: "https://86fee21cd77593a10285503917cb3536@o4510464309133312.ingest.us.sentry.io/4510464453771264",

  sendDefaultPii: true,
  enabled: environment.sentryEnabled,
  release: (document as any).SENTRY_RELEASE || 0,
  environment: environment.production ? 'production' : 'staging'
});

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
